import { createAction, props } from '@ngrx/store';

export const setPractitionerId = createAction(
  '[Booking] Set Practitioner ID',
  props<{ practitionerId: number | undefined }>()
);

export const setServiceId = createAction(
  '[Booking] Set Service ID',
  props<{ serviceId: number | undefined }>()
);

export const setStartDateTime = createAction(
  '[Booking] Set Start DateTime',
  props<{ startDateTime: string | undefined }>()
);

export const setCaseId = createAction(
  '[Booking] Set Case ID',
  props<{ caseId: number | undefined }>()
);

export const setBookingReasonId = createAction(
  '[Booking] Set Booking Reason ID',
  props<{ bookingReasonId: number | undefined }>()
);

export const setTreatmentPlanId = createAction(
  '[Booking] Set Treatment Plan ID',
  props<{ treatmentPlanId: number | undefined }>()
);

export const setIntegrationId = createAction(
  '[Booking] Set Integration ID',
  props<{ integrationId: number | undefined }>()
);

export const setPartnerToken = createAction(
  '[Booking] Set Partner Token',
  props<{ partnerToken: string | undefined }>()
);

export const setPartnerUnauthBooking = createAction(
  '[Booking] Set Partner Unauth Booking',
  props<{ partnerUnauthBooking: boolean | undefined }>()
);

export const setSysAppointmentDeliveryMethodId = createAction(
  '[Booking] Set Delivery Method',
  props<{ sysAppointmentDeliveryMethodId: number | undefined }>()
);

export const setIsForWaitingListFlag = createAction(
  '[Booking] Set waiting flag',
  props<{ isForWaitingList: boolean | undefined }>()
);

export const setReturnPath = createAction(
  '[Booking] Set return path',
  props<{ returnPath: string | undefined }>()
);
